import * as yup from 'yup';

const requiredErrorMessage = 'Field is required';

const licenseSchema = {
  type: yup.string().required(requiredErrorMessage),
  id: yup
    .string()
    .max(50)
    .matches(/^[A-Za-z0-9-]{1,50}$/, 'License ID is invalid')
    .required(requiredErrorMessage),
};

export const licensesSchema = yup.object().shape({
  licenses: yup
    .array()
    .of(yup.object().shape(licenseSchema))
    .min(1, 'Must have at least 1 license'),
});
